import React from "react";
import LinkedShows from "./LinkedShows";
import SectionPanel from "components/panels/SectionPanel/SectionPanel";
import PanelSegment from "components/panels/PanelSegment/PanelSegment";

interface Props {
  documentType: server.dto.DocumentTypes
  linkedShowsPanel: server.dto.LinkedShowPanel
  startUncollapsed?: boolean
}

const ReadonlyLinkedShowsPanelSegment = (props: Props) => {
  return <SectionPanel.Panel
    header={<>
      <PanelSegment.Title title={site.currentEnvironment.show.plural} />
    </>}
    collapsible={{
      persist: false,
      start: props.startUncollapsed ? "open" : "closed",
      uniqueRowId: "linkedShowsPanel"
    }}
  >
    <LinkedShows
      documentType={props.documentType}
      displayLinkShowsModal={false}
      onDisplayLinkShowsModalToggled={() => { /* */ }}
      queryKey={["readonly-linked-shows"]}
      initialShowCount={props.linkedShowsPanel.data.collection.length}
      config={props.linkedShowsPanel.config}
      disabled
      defaultBookkeeping={undefined}
    />
  </SectionPanel.Panel>
};

export default ReadonlyLinkedShowsPanelSegment;